import React, { useCallback, useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
// import { invokeApiRemote } from '../../../../../services/invokeApi';
// import { fetchAllTestCaseExecutions } from '../../../../../services/test-cycles/executions';
import { executionTableHeaders } from '../../test-case/testCaseTableHead';
import TableComponent from '../../../elements/TableComponent';
import { getDateAndTime } from '../../../../lib/utils';
import { useNotification } from '../../../../hooks/NotificationContext';
import { getTestCaseExecutions } from '../../../../modules/executions';
import { useParams } from 'react-router-dom';
import { showUserDisplayName } from '../../../../lib/userUtils';

const TestCaseExecutionTable = ({ testCaseId, users, testCaseKey }) => {
  const [testExecutions, setTextExecutions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();
  const { projectId } = useParams();
  const fetchTestCaseData = async () => {
    setLoading(true);
    try {
      const response = await getTestCaseExecutions(testCaseId);
      setTextExecutions(response?.data);
    } catch (error) {
      const errorMessage =
        error?.message || 'Failed to fetch executions.';
      addNotification('danger', errorMessage);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (testCaseId) {
      fetchTestCaseData();
    }
  }, [testCaseId]);

  const formData = () => {
    return (
      testExecutions &&
      testExecutions.map((exe) => ({
        key: exe?.key,
        id: exe?.id,
        status: exe?.status,
        environment: exe?.iteration?.environment_details?.name || 'None',
        iteration: exe?.iteration?.name || 'None',
        testCycleKey: exe?.testcycle?.key,
        testCycleId: exe?.testcycle?.id,
        testCaseId: exe?.association?.testcase?.id,
        testCaseKey: testCaseKey,
        associatedTestCaseId: exe?.association?.id,
        jiraIssueDetails: exe?.jira_issue_details || [],
        executedBy: showUserDisplayName(exe?.executed_by, users),
        // assignedTo: showUserDisplayName(exe?.association?.assigned_to, users),
        actualTime: exe?.actual_time,
        executionTime: getDateAndTime(exe?.updated_at),
        projectId
      }))
    );
  };
  const formattedData = useCallback(() => {
    return formData();
  }, [testCaseId, testExecutions]);

  const finalData = formattedData();
  return (
    <Container fluid className="px-0">
      <Card className="shadow-sm mb-4">
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{ height: '50px' }}>
          <h5 className="mb-0">Test Case Execution</h5>
        </Card.Header>
        <Card.Body>
          <TableComponent
            data={finalData || []}
            headerTabs={executionTableHeaders}
            isLoading={loading}
            page={0}
            striped
            perPage={10}
            selected={selected}
            setSelected={setSelected}
            showCheckbox={false}
          />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TestCaseExecutionTable;
